import {Organization} from "../../utils/types/AiTypes";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {API_ORGANIZATION_LIST_ENDPOINT} from "../../utils/constants";

export interface OrganizationState {
    organizations: Organization[];
    currentPage: number,
    size: number
    totalPage: number,
    totalElements: number,
    status: "fulfilled" | "pending" | "rejected" | "idle";
}

interface OrganizationListPagination {
    data: Organization[],
    currentPage: number,
    totalPage: number,
    totalElements: number,
}

const initialState: OrganizationState = {
    organizations: [],
    currentPage: 1,
    size: 10,
    totalPage: 1,
    totalElements: 0,
    status: "idle"
}

export const fetchOrganization = createAsyncThunk(
    "organization/list",
    async (params: {keycloak: Keycloak.KeycloakInstance, page: number, size: number}): Promise<OrganizationListPagination> => {
        const {keycloak, page, size} = params;
        const res = await axios.get(`${API_ORGANIZATION_LIST_ENDPOINT}`, {
            params: {
                page: page,
                size: size
            },
            headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                Authorization: `Bearer ${keycloak?.token}`,
            },
            withCredentials: true,
        });
        return res.data;
    }
);


export const OrganizationsSlice = createSlice({
    name: 'aiTemplates',
    initialState,
    reducers: {
        getOrganizations: (state, action) => {
            state.status = 'fulfilled';
            state.organizations = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalPage = action.payload.totalPage;
        },
        failedToGetOrganizations: (state) => {
            state.status = 'rejected';
            state = initialState
        },
        resetOrganizationsState: (state) => {
            state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchOrganization.fulfilled, (state, action) => {
            state.status = "fulfilled";
            state.organizations = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalPage = action.payload.totalPage;
            state.totalElements = action.payload.totalElements;
        })
    }
});

export const { getOrganizations, failedToGetOrganizations,resetOrganizationsState} = OrganizationsSlice.actions;
export default OrganizationsSlice.reducer;